module.exports = __webpack_public_path__ + "fonts/font.8ffd0aee.woff2";